import { IconProps } from '@/components/icon';

export const SlackIntegrationKey = '_supersimple.slack.v1';

export const getIntegrationIcon = (service: string): IconProps['name'] | undefined => {
  switch (service) {
    case 'NOTION':
      return 'Notion';
    case 'GOOGLE_DRIVE':
      return 'GoogleDrive';
    case 'SLACK':
      return 'Slack';
    default:
      return undefined;
  }
};
